<template>
  <section
    id="venue"
    class="sections sections--parallax sections--parallax__v"
  >
    <v-container>
      <v-row align="center">
        <v-col cols="12" sm="6">
          <div class="sections-box">
            <div class="sections--border">
              <span class="sections--title">Pameran</span>
              <h2 class="sections--menu">Virtual Venue</h2>
            </div>
          </div>
          <div class="my-10">
            <p>
              Kunjungi pameran Songket Indonesia oleh Museum Nasional secara daring dengan perspektif 360º dan ciptakan pengalaman melihat beragam songket secara detil dan informatif.
            </p>
          </div>
          <div>
            <v-btn text class="highlights--button">
              <span>IKUTI VIRTUAL VENUE</span>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card
            flat
            class="features--card d-flex align-center justify-center"
            height="250"
          >
            <div class="text-center">
              <p
                class="
                  text-h4
                  font-weight-bold
                  text-center
                  mb-10
                  text-uppercase
                "
              >
                <span>Pameran</span> <br />
                VIRTUAL VENUE
              </p>
              <p>
                <v-icon x-large color="white" class="mb-1">
                  mdi-play-circle
                </v-icon>
                <br />
                <span class="text-uppercase font-weight-bold"> bergabung </span>
              </p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
